exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.iong{margin:0 auto;padding-top:1em}@media only screen and (max-width:767px){.iong .ui.cards{justify-content:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/Iah/Iong/Iong.css
// module id = 663
// module chunks = 0